import React, {useMemo, useState} from "react";
import styled from "styled-components";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCirclePlus} from "@fortawesome/pro-light-svg-icons";
import {useQuery} from "react-query";
import {blueprints, cpx} from "../../../../utils/const/query-key";
import apiService from "../../../../api/apiService";
import BlueprintResultsTable from "./blueprintsResultsTable/BlueprintResultsTable";
import {configBlueprintTable} from "../../demoPointEnv/envResultsTable/config/config";
import {useNavigate} from "react-router-dom";
import CpToggle from "./CpToggle";
import Loading from "../../Loading";


const ButtonContainer = styled.div`
  text-align: right;
`;

const CreateEnvButton = styled.button`
  margin-top: 10px;
  font-size: 14px;
  cursor: pointer;
  color: var(--color-brand-pink-primary);
  border: none;
  background-color: transparent;
`;
const Header = styled.div`
  font-size: 30px;
  margin-top: 10px;
`;

const Title = styled.div`
  display: flex;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between
`;

const TitleBackLocation = styled.div`
  color: black;
  cursor: pointer;
`;
const TitleCurrentLocation = styled.div`
  display: flex;
  color: var(--color-text-title);
`;

const DemoBlueprints = () => {
    const navigate = useNavigate();
    const {data: isCpx, status: isCpxStatus} = useQuery(cpx, () => apiService.getIsCpx());

    const {data} = useQuery(blueprints, () =>
        apiService.getAllBlueprints()
    );

    const [filter, setFilter] = useState("All");
    const dataFiltered = useMemo(() => {
        if (filter !== "All") {
            return data.filter((bp) => (bp.category === filter))
        }
        return data
    }, [filter, data])

    if (isCpxStatus === 'loading') {
        return <Loading/>;
    }
    return (
        <div>
            <Title>
                <TitleBackLocation onClick={() => navigate("/demo-point")}>Demo Point Home </TitleBackLocation>
                <TitleCurrentLocation>/ Admin Demo Point BluePrints</TitleCurrentLocation>
            </Title>
            <Header>
                <div>DemoPoint BluePrints</div>
                <ButtonsWrapper>
                    <CpToggle id={"toggle_cpx"} toggleName={"CPX Mode"} initialState={isCpx} shouldConfirm />
                    <ButtonContainer id="newBlueprintButton">
                        <CreateEnvButton id={"create_blueprint_button"}
                                         onClick={() => navigate("/admin/create-blueprint")}>
                            <FontAwesomeIcon icon={faCirclePlus}/> Create Blueprint
                        </CreateEnvButton>
                    </ButtonContainer>
                </ButtonsWrapper>
            </Header>
            {data && <BlueprintResultsTable data={dataFiltered} columns={configBlueprintTable.columns}
                                            filter={filter} setFilter={setFilter}/>}
        </div>
    )
};
export default DemoBlueprints;
